import Vue from 'vue';
import Vuex from 'vuex';
import api from './api/api';
import {
  authModule,
  categoriesModule,
  areasModule,
  locationsModule,
  citiesModule,
  tagsModule,
  reasonsModule,
  jobsModule,
  campaignsModule,
  employersModule,
  pagesModule,
  usersModule,
  localModule,
  initialLoad
} from './store.modules.js';
import AnalyticsService from '@/services/analytics.service.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    /* TODO: Migrate all calls to modules
    authModule,
    categoriesModule,
    areasModule,
    locationsModule,
    citiesModule,
    tagsModule,
    reasonsModule,
    jobsModule,
    campaignsModule,
    pagesModule,
    usersModule,
    localModule */
    employers: employersModule
  },
  state: {
    JWT: null,
    userRoles: null,
    categories: null, // list of position categories
    categoriesWithDetails: null, // list of categories with details
    tags: null, // list of position tags
    reasonsToReport: null,
    reasonsToHide: null,
    reasonsToHideAdmin: null,
    jobs: initialLoad, // Updated on app load, will contain the whole data from API
    campaignJobs: [],
    searchResults: initialLoad, // This is updated when a search is done
    mapVisibility: null,
    searchTerms: {
      area: '',
      keywords: '',
    }, // Takes object with keys 'keyword' and 'area'
    userFavorites: [],
    selectedPosition: null, // Taked the position info as an object
    // Map data contans SVG coords and area names. Here because area names are also used in Admin.
    mapData: [
      {
        id: 'paijatHame',
        name: 'Päijät-Häme',
        shape: 'm883.12059,2901.08l-9.849,-12.64l10.055,-8.49l-17.527,-21.31l7.412,-30.27l27.466,-16.37l-2.187,-37.37l-14.746,-11.39l-11.534,5.45l3.196,-11.97l-24.673,-9.87l-2.195,-52.6l8.628,4.99l77.005,-7.23l15.574,-56.07l23.388,-10.73l12.409,5.9l16.283,-28.15l18.158,9.13l20.772,32l29.3,11.6l-10.08,26.84l-3.47,31.96l9.5,6.76l0.71,12.59l14.42,13.51l8.63,1.25l1.16,15.57l-9.26,5.14l-7.9,20.73l-21.04,14.24l-21.8,-0.07l-3.7,13.39l5.82,12.59l4.38,22.45l-12.442,-0.76l-5.398,10.3l16.04,6.88l-7.74,14.69l0.598,16.95l13.572,8.99l2.23,15.71l4.29,2.14l-1.65,13.9l-13.21,7.08l-12.68,-11.38l-19.892,4.34l-0.768,-13.75l-13.34,9.42l-8.567,-1.41l-28.14,8.72l-8.494,-7.96l-7.001,-25.4l-4.732,-4.22l-15.835,16.58l-20.428,-24.84l-10.718,2.46z',
        center: {
          x: 200,
          y: 200,
        },
        cities: [
          {
            x: 1008.15359,
            y: 2871,
            id: "lahti",
            name: "Lahti"
          }
        ]
      },
      {
        id: 'southOstrobothnia',
        name: 'South Ostrobothnia',
        shape: 'm379.40559,2498.8l13.366,12.24l33.338,5.91l38.44,-32.69l11.775,-0.05l20.651,-31.7l15.547,-0.53l13.325,-27.19l18.313,9.1l11.261,0.09l28.768,0.1l31.449,-17.17l14.337,-25.29l27.707,10.82l3.873,-9.8l20.879,2.98l25.748,-21.2l11.517,7.33l2.943,24.23l11.337,4.71l20.286,-23.33l26.294,3.81l6.083,-11.17l22.132,-0.34l5.686,-38.62l-7.539,-10.3l5.515,-7.85l-22.392,-61.02l9.04,-7.08l-13.162,-17.66l-4.708,-38.18l10.365,-14.41l-29.43,-13.91l12.991,-5.36l-25.292,-31.96l-24.579,-7.38l-27.22,-35.8l-14.176,-17.36l-17.538,-8.44l-23.947,-0.33l-9.077,26.63l-12.002,10.54l-17.302,-4.98l-32.785,5.77l-31.12,15.16l-0.361,24.38l7.997,0.27l6.362,27.93l-16.31,-0.2l-34.209,59.29l2.515,16.98l-29.424,30.93l-36.65,-12.19l-23.463,-24.48l-6.639,7.75l-3.528,36.41l7.459,7.53l-24.276,26.33l-19.422,57.44l7.633,18.86l10.977,3.62l0.569,28.25l6.63,2.85l7.199,10.5l-15.108,9.64l2.796,14.42l-8.207,6.49l-3.237,28.68z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 555.15359,
            y: 2289,
            id: "seinajoki",
            name: "Seinäjoki"
          }
        ]
      },
      {
        id: 'kantaHame',
        name: 'Kanta-Häme',
        shape: 'm851.91459,2749.52l-17.579,7.87l-11.768,-11.76l-5.416,12.24l-24.791,-9.64l-28.545,22.38l-4.769,-3.61l-3.453,5.42l0.372,6.48l3.317,3.91l-8.819,10.5l-68.785,26.1l4.223,32.38l-5.114,5.01l-20.474,-22.37l-29.912,11.4l-14.462,0.22l-2.28,-10l-14.263,-10.82l-10.286,6.3l-0.212,8.26l12.191,7.29l-8.15,19l-14.566,2.97l-1.392,13.91l8.24,9.63l-6.804,6.09l0.761,11.93l25.332,13l19.19,-9.58l35.463,27.22l31.437,10.41l45.646,7.86l5.63,12.47l10.808,-8.28l11.115,5.3l2.72,10.36l27.92,-5.49l-1.216,-14.34l7.855,-10.58l17.561,2.61l39.79,-8.22l16.37,5.67l10.365,-18.91l-10.881,-3.7l10.022,-22.68l-9.853,-12.62l10.055,-8.49l-17.527,-21.31l7.412,-30.27l27.466,-16.37l-2.187,-37.37l-14.746,-11.39l-11.534,5.45l3.196,-11.97l-24.673,-9.87z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 791.15359,
            y: 2821,
            id: "hameenlinna",
            name: "Hämeenlinna"
          }
        ]
      },
      {
        id: 'southKarelia',
        name: 'South Karelia',
        shape: 'm1324.39359,2956.64l-17.96,-9.18l-7.84,-19.29l-16.227,-2.41l-7.292,-14.78l-21.648,0.53l-19.12,-10.18l-6.892,-12.1l-25.558,-7.46l-7.652,-13.07l7.992,-4.77l-14.43,-17.61l5.1,-17.21l15.878,-5.91l-10.148,-23.04l21.43,-5.15l-7,-14.22l6.08,-11.79l-17.822,-19.07l-18.178,2.65l-18.79,-11.25l6.49,-9.94l15.279,1.27l3.711,-6.99l37.868,0.18l23.83,14.3l21.142,-8.67l33.037,6.79l49.55,-4.32l25.31,-31.31l7.55,-18.71l14.19,10.83l37.31,-0.23l4.82,-16.94l30.45,1.37l30.7,-9.83l18.96,-31.48l24.17,-8.18l5.63,-16.03l89.32,-47.96l-2.9,2.96l-11.94,33.78l-30,27.62l-20.18,42.36l-25.42,18.01l-5.74,17.76l-37.74,63.63l-44.17,30.65l-15.8,6.43l-18.97,32.49l-2.4,21.3l-20.41,4.55l-38.24,33.47l-7.34,19.62l-37.99,36.53z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 1348.15359,
            y: 2811,
            id: "lappeenranta",
            name: "Lappeenranta"
          }
        ]
      },
      {
        id: 'kymenlaakso',
        name: 'Kymenlaakso',
        shape: 'm1088.36659,3021.56l1.4,-23.07l20.7,-21.7l13.448,-0.32l-6.188,-16.39l-10.54,-0.67l-6.232,12.05l-13.608,-1.3l-5.28,-13.02l-9.54,-0.3l-7.97,-20.13l-16.25,-7.8l-3.84,-1.84l-2.23,-15.71l-13.572,-8.99l-0.598,-16.95l7.74,-14.69l-16.04,-6.88l5.398,-10.3l12.442,0.76l-4.38,-22.45l-5.82,-12.59l3.7,-13.39l21.8,0.07l21.04,-14.24l7.9,-20.73l9.26,-5.14l10.82,-4.36l16.068,25.49l15.072,-7.78l0.258,-15.56l20.122,0.42l0.06,26.75l27.908,13.84l16.202,-5.44l10.128,23l-15.878,5.91l-5.1,17.21l14.43,17.61l-7.992,4.77l7.652,13.07l25.558,7.46l6.892,12.1l19.12,10.18l21.648,-0.53l7.292,14.78l16.227,2.41l7.84,19.29l17.96,9.18l-15.81,15.21l-0.49,10.13l-10.34,6.84l-12.049,-7.89l-4.808,3.69l-3.75,16.83l-5.311,8.68l-8.029,0.25l-9.732,1.41l-6.37,-3.52l-5.848,3.93l-7.05,6.63l-9.05,-13.42l-23.472,-2.76l-28.46,-9.3l-11.518,11.58l0.34,18.57l-4.152,7.45l-11.67,-0.36l-13.388,-13.36l-7.82,7.12l-10.01,0.35l-6.26,-6.61l-6.63,4.6l-13.35,-0.13z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 1148.15359,
            y: 2976,
            id: "kotka",
            name: "Kotka"
          }
        ]
      },
      {
        id: 'uusimaa',
        name: 'Uusimaa',
        shape: 'm892.68059,3082.47l5.694,-1.56l2.199,-6.71l7.139,-1.96l24.369,-0.63l6.155,-7.54l0.363,-13.27l16,-1.8l3.975,14.64l12.683,15.68l5.024,0.95l7.457,-8l8.249,5.12l4.271,-5.49l-4.683,-14.93l4.198,-3.4l8.394,17.19l5.125,-2.03l-0.934,-12.51l4.962,-1.72l7.63,3.77l5.618,-2.44l-9.399,-16.56l-2.641,-10.53l-9.567,-12.85l1.365,-8.1l15.599,14.82l10.934,11.2l5.155,11.45l6.078,-0.48l5.249,-8.45l-1.106,-14.63l9.989,-0.56l5.214,11.22l7.489,0.27l16.19,-15.83l0.794,0l1.347,-23.22l20.803,-21.7l13.515,-0.32l-6.219,-16.39l-10.592,-0.67l-6.263,12.05l-13.676,-1.3l-5.306,-13.02l-9.588,-0.3l-8.009,-20.13l-16.074,-7.68l0.004,-0.04l-0.261,-0.08l0.257,0.12l-1.463,14.08l-13.276,7.08l-12.743,-11.38l-19.991,4.34l-0.772,-13.75l-13.406,9.42l-8.61,-1.41l-28.28,8.72l-4.494,-4.19l-6.719,-24.26l-4.756,-4.22l-15.913,16.58l-20.53,-24.84l-10.767,2.44l-10.072,22.68l10.935,3.7l-10.417,18.91l-16.451,-5.67l-39.988,8.22l-17.648,-2.61l-7.894,10.58l1.222,14.34l-28.059,5.49l-2.734,-10.36l-11.17,-5.3l-10.862,8.28l-5.658,-12.47l-45.873,-7.86l-4.895,6.97l5.534,9.44l-11.115,24.75l-23.3,3.18l-1.328,13.77l10.216,4.13l3.207,19.21l-9.901,1.04l-2.963,19.75l-14.977,5.13l1.106,34.16l-16.095,-7.5l-28.754,14.21l-9.669,-7.65l-18.906,19.69l-25.112,0.47l0.001,-0.01l-0.268,0.02l0.267,-0.01l-4.173,35.42l-9.11,-4.68l-11.276,0.49l-2.413,11.75l9.768,12.84l17.81,3.09l4.761,-4.62l0.42,-15.82l5.636,-4.52l4.787,7.37l-2.597,19.28l-5.636,6.76l-27.777,9.75l-6.508,7.3l6.953,8.74l20.824,-8.61l25.166,0.2l13.01,-11.06l0.001,-7.18l9.976,-11l12.138,1.56l7.826,5.55l16.039,-3.41l12.602,2.72l6.479,-4.93l-2.56,-9.31l18.191,-1.66l36.869,-15.72l30.377,-0.66l22.178,-12.2l-0.926,19.16l4.754,0.05l6.966,-6.04l6.048,3.48l-13.002,16.97l9.558,0.74l29.506,-36.89l-0.039,-9.89l2.159,-5.12l5.236,5.22l26.891,-9.4l10.094,6.85l14.191,0.2l4.79,-7.56l2.125,11.66l10.862,-9.14l-1.702,-12.54l10.852,3.34l7.784,-10.51l2.264,-6.96z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 833.15359,
            y: 3104,
            id: "helsinki",
            name: "Helsinki"
          }
        ]
      },
      {
        id: 'lapland',
        name: 'Lapland',
        shape: 'm916.43559,1408.24l-0.603,0.56l14.973,-15.19l21.272,-11.04l3.187,-14.76l53.352,3.05l46.469,-29.27l3.5,29.98l91.841,7.95l31.14,-10.61l42.46,-69.18l13.548,6.17l10.302,-4.88l13.85,34.38l67.417,10.66l29.8,-13.02l1.13,-19.02l-14.73,-22.2l18.33,-8.87l18.11,5.14l5.47,-4.45l-0.36,-16.79l-12.53,-9.13l0.32,-17.34l9.37,-1.46l4.54,-31.27l-18.45,-7.76l-12.64,-27.2l4.88,-18.33l14.98,-5.93l-0.49,-16.63l74.24,17.41l45.23,-5.81l-11.97,-32.05l-64.45,-108.83l7.45,-24.571l98.09,-183.965l3.71,-45.026l-46.13,-34.518l-47.27,-96.504l-72.28,-29.403l-24.46,-101.983l28.79,-51.896l6.47,-46.476l-8.13,-13.774l-32.78,0.115l53.91,-45.357l-10.3,-36.104l3.49,-33.712l51.85,-67.375l-29.29,-74.69l-87.25,-42.991l-2.03,-18.954l-26.7,-16.798l-27.667,-38.538l-15.6,9.832l-15.42,-5.003l-10.69,15.525l-42.75,33.895l-49.362,-12.859l-28.378,9.947l-17.31,41.213l-29.21,25.991l-14.37,23.035l5.518,15.969l-9.388,17.1l-18.3,104.68l3.699,62.153l-9.979,34.994l-20.333,-5.209l-18.446,11.084l-25.144,36.985l2.815,35.746l-17.256,-0.108l-6.169,12.6l-24.128,-29.705l-43.631,-19.086l-41.214,-30.534l-20.843,10.942l-11.038,19.465l-27.543,9.73l-29.164,13.143l-6.94,-14.352l-32.071,-3.328l-30.669,-22.204l-17.71,7.449l2.038,-34.405l-70.007,-141.933l-41.385,-14.376l-25.771,12.677l-17.275,20.645l10.144,26.789l-5.201,18.099l-32.653,-25.286l-23.136,22.638l29.661,38.358l1.763,26.327l22.722,6.127l32.563,67.603l23.755,7.378l8.727,21.918l22.203,10.864l9.007,26.051l32.526,7.416l43.308,19.857l47.04,43.345l0.086,28.886l6.202,16.995l14.348,-2.015l5.986,28.5l26.428,27.515l-10.997,13.072l-8.7,14.664l-0.4,18.456l1.19,56.709l-15.065,38.725l11.623,20.925l27.565,4.754l-7.028,15.869l5.327,18.259l-23.72,12.329l-1.096,31.449l47.498,109.766l-17.498,19.34l-3.409,56.2l-17.689,15.34l-4.738,15.46l-5.99,18.52l4.17,16.74l-4.599,11.95l7.845,38.93l20.167,19.56l1.079,20.6l16.783,27.39l1.479,19.75l10.151,27.34l0.258,21.97l11.08,-1.28l7.745,-12.34l9.676,11.62l20.89,7.73l6.523,9.66l-7.339,15.4l5.289,6.12l10.14,-6.62l3.94,12.7l8.247,-0.84l6.981,-5.7l13.914,2.07l8.288,10.72l8.874,-0.82l6.53,6.69z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 951.15359,
            y: 1126,
            id: "rovaniemi",
            name: "Rovaniemi"
          }
        ]
      },
      {
        id: 'northKarelia',
        name: 'North Karelia',
        shape: 'm1352.34359,1985.69l19.55,21.76l15.45,1.17l3.94,31.91l8.67,7.04l-6.59,9.63l3.92,36.7l15.24,8.99l0.37,21.6l-13.57,24.82l10.88,9.76l23.16,48.66l32.4,16.7l-21.68,15.73l17.6,23.77l-18.52,25.45l-24.85,-10.83l-4.03,12.12l-13.02,3.46l17.8,39.27l12.16,3.74l27.8,25.55l1.9,10.57l14.3,12.06l-6.03,14.28l14.01,10.03l14.14,-8.62l8.4,10.33l0.01,16.63l18.69,30.49l11.09,60.76l19.19,8.39l7.7,17.64l-6.34,7.99l11.26,22.85l-12.7,36.84l89.54,-48.44l17.72,-18.34l39.89,-69.86l28.72,-44.01l18.9,-7.39l35.07,-65.23l41.51,-131.66l-12.11,-30.57l-35,-28.46l-11.58,-39.83l-24.94,-17.22l-31.74,-25.01l-44.78,-20.33l-18.03,-25.46l-52.82,-56.38l-25.05,-2.26l-13.51,14.72l-20.79,-52.89l-100.24,17.89l-67.36,-12.45l-15.7,35.94z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 1733.15359,
            y: 2334,
            id: "joensuu",
            name: "Joensuu"
          }
        ]
      },
      {
        id: 'southSavo',
        name: 'South Savo',
        shape: 'm1128.68659,2400.27l-10.5,7.28l16.558,18.28l-14.659,5.19l-8.659,36.75l-17.591,-8.94l-24.469,15.18l-13.81,28.19l22.14,40.63l-6.5,9.8l5.15,54l21.188,31.21l-5.218,19.26l-18.68,-5.97l-2.63,7.05l-9.98,26.7l-3.47,31.94l9.5,6.74l0.71,12.59l14.42,13.5l8.63,1.25l1.16,15.55l10.82,-4.35l16.07,25.47l15.07,-7.77l0.26,-15.55l20.12,0.41l0.06,26.74l27.908,13.83l16.182,-5.48l21.43,-5.15l-7,-14.21l6.08,-11.78l-17.82,-19.05l-18.18,2.64l-18.79,-11.24l6.49,-9.92l15.278,1.26l3.71,-6.98l37.87,0.18l23.832,14.29l21.14,-8.67l33.037,6.79l49.55,-4.32l25.31,-31.28l7.55,-18.7l14.19,10.82l37.31,-0.23l4.82,-16.93l30.45,1.37l30.7,-9.82l18.96,-31.46l24.17,-8.17l5.63,-16.02l0.46,-0.24l12.7,-36.84l-11.26,-22.85l6.34,-7.99l-7.7,-17.64l-19.19,-8.39l-11.09,-60.76l-18.69,-30.49l-0.01,-16.63l-8.4,-10.33l-14.14,8.62l-14.01,-10.03l6.03,-14.28l-14.3,-12.06l-1.9,-10.57l-27.8,-25.55l-12.16,-3.74l-10.01,2.92l-25.96,25.64l-13.65,0.01l0.04,29.32l-11.86,-1.47l-9.38,15.55l10.81,8.2l-6.23,12.76l17.67,-0.69l1.24,15l16.6,-4.06l22.87,28.48l-7.23,17.72l-45.79,-17.86l-28.46,3.25l-17.37,-15.32l-25.5,-1.51l-14.689,-25.63l-50.92,-44.28l-24.448,16.56l-10.56,-13.41l-21.35,5.32l-5.52,8.29l-14.872,-6.49l-15.808,8.57z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 1173.15359,
            y: 2654,
            id: "mikkeli",
            name: "Mikkeli"
          }
        ]
      },
      {
        id: 'northSavo',
        name: 'North Savo',
        shape: 'm1369.44359,2361.97l13.65,-0.01l25.96,-25.64l10.01,-2.92l-17.8,-39.27l13.02,-3.46l4.03,-12.12l24.85,10.83l18.52,-25.45l-17.6,-23.77l21.68,-15.73l-32.4,-16.7l-23.16,-48.66l-10.88,-9.76l13.57,-24.82l-0.37,-21.6l-15.24,-8.99l-3.92,-36.7l6.59,-9.63l-8.67,-7.04l-3.94,-31.91l-15.45,-1.17l-19.55,-21.76l-10.91,25.32l-40.13,-46.29l-61.647,-39.46l-51.082,-3.89l-43.168,-16.35l-34.4,11.59l-49.73,46.03l7.44,75.53l-8.27,4.96l-16.13,45.65l-7.04,25.94l10.6,14.45l3.34,53.01l20.46,28.17l-12.182,8.14l9.642,9.54l-8.02,13.51l-29.31,3.81l41.72,52.16l12.29,-3.03l17.75,27.1l4.888,28.68l-19.578,20.95l0.038,8.49l22.29,14.27l10.83,-1.39l6.652,7.69l15.808,-8.57l14.872,6.49l5.52,-8.29l21.35,-5.32l10.56,13.41l24.448,-16.56l50.92,44.28l14.689,25.63l25.5,1.51l17.37,15.32l28.46,-3.25l45.79,17.86l7.23,-17.72l-22.87,-28.48l-16.6,4.06l-1.24,-15l-17.67,0.69l6.23,-12.76l-10.81,-8.2l9.38,-15.55l11.86,1.47l-0.04,-29.32z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 1328.15359,
            y: 2236,
            id: "kuopio",
            name: "Kuopio"
          }
        ]
      },
      {
        id: 'kainuu',
        name: 'Kainuu',
        shape: 'm1145.40659,1905.02l43.168,16.35l51.082,3.89l61.647,39.46l40.17,46.34l26.7,-61.52l67.36,12.46l100.24,-17.9l20.79,52.92l13.51,-14.73l25.18,2.25l-1.79,-1.76l32.24,-22.99l34.13,-89.07l-10.58,-49.21l-54.09,-37.1l-15.44,-41.54l-0.09,-22.72l11,-9.66l0.65,-20.02l-10.58,-13.24l4.45,-15.95l-50.4,-10.35l-14.83,-57.06l5.36,-20.07l19.24,-6.41l7.59,-15.72l-6.99,-9.28l8.53,-17.5l-8.14,-9.42l-26.11,-2.41l10.92,-36.95l2.15,-32.4l3.43,-11.54l-36.86,7.65l-34.95,-1.65l-6.03,-5l-12.43,26.64l-14.77,4.44l-8.69,-7.09l-40.89,19.3l-3.37,33.55l-72.26,12.97l-14.88,9.06l-6.109,37.51l-14.198,-9.8l-16.142,-2.11l-14.489,10.81l-27.869,-0.12l-12.69,20.85l17.13,14.33l2.46,40.85l-5.71,15.39l-30.44,-7.01l-0.84,7.38l-25.89,12.34l-10.01,29.03l-28.36,13.83l-4.92,15.93l-13.21,3.87l-25.05,25.57l13.21,8.67l7.4,16.38l-2.27,14.17l14.48,12.69l11.72,-1.62l15.598,10.37l-0.008,70.04l10.84,13.63z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 1221.15359,
            y: 1846,
            id: "kajaani",
            name: "Kajaani"
          }
        ]
      },
      {
        id: 'centralFinland',
        name: 'Central Finland',
        shape: 'm733.99159,2410.3l0.102,28.14l21.356,12.77l11.21,-2.11l7.713,22.03l20.537,4.08l12.815,-4.6l22.393,23.78l7.127,26.15l-14.38,22.99l-4.278,-7.61l-13.394,19.41l34.075,42.57l7.015,1.23l-0.084,6.38l-7.177,0.45l-2.186,-6.1l-5.503,3.68l2.861,9.72l-1.122,12.03l7.546,4.53l2.422,-1.37l9.933,5.91l-9.685,6.77l-4.286,9.44l2.149,12.78l18.385,15.17l-1.188,23.39l77.005,-7.23l15.574,-56.07l23.388,-10.73l12.409,5.9l16.283,-28.15l18.158,9.13l20.772,32l29.2,11.72l2.63,-7.05l18.68,5.98l5.218,-19.28l-21.188,-31.24l-5.152,-54.04l6.5,-9.8l-22.138,-40.66l13.808,-28.21l24.472,-15.2l17.59,8.95l8.66,-36.77l14.66,-5.19l-16.56,-18.3l10.5,-7.28l-6.652,-7.7l-10.829,1.4l-22.289,-14.29l-0.04,-8.49l19.579,-20.97l-4.889,-28.7l-17.75,-27.12l-12.29,3.03l-41.72,-52.19l29.308,-3.82l8.022,-13.52l-9.64,-9.54l12.18,-8.15l-20.46,-28.19l-3.47,-52.97l-10.47,-14.54l6.91,-25.85l-30.862,0.22l-8.908,-18.82l-9.49,-7.91l-23.581,-0.07l-46.666,-32.02l-14.721,6.12l-6.475,40.23l-18.016,2.04l-12.247,2.09l-24,25.57l-2.542,69.45l-22.901,-4.99l-26.271,9.69l-6.154,4.04l-10.086,14.2l4.708,38.18l13.162,17.66l-9.04,7.08l22.392,61.02l-5.515,7.85l7.539,10.3l-5.686,38.62l-22.132,0.34l-6.083,11.17l-26.294,-3.81l-20.456,23.27z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 968.15359,
            y: 2461,
            id: "jyvaskyla",
            name: "Jyväskylä"
          }
        ]
      },
      {
        id: 'ostrobothnia',
        name: 'Ostrobothnia',
        shape: 'm698.23159,2089.8l7.844,-25.35l-20.418,-37.05l-8.416,2.39l-9.07,-16.03l13.739,-8.89l10.757,8.77l17.261,-0.4l8.373,-8.97l-36.775,-29.57l-10.623,8.24l-6.048,-9l-23.091,11.26l-32.694,-24.41l-6.222,8.43l-14.109,-38.95l-9.143,13.68l-9.868,6.53l2.748,16.1l-1.562,11.79l-12.06,7.7l-1.833,8.66l-6.667,2.88l-9.577,8.25l-1.006,4.87l-8.969,6.55l-3.771,16.51l-6.554,-8.6l-6.82,3.74l-4.952,21.45l-7.598,0.45l-3.955,5.24l2.387,7.74l5.503,5.53l12.075,27.1l-4.415,10.73l-11.064,0.22l-8.106,15.38l-12.94,3.03l-34.563,-12.39l-24.606,10.36l-11.468,0.25l-4.836,-14.45l-8.028,8.15l-0.767,21.67l-8.387,10.42l1.227,7.85l9.898,8.62l3.127,7.74l-5.131,1.99l-9.138,-2.43l-6.3203,2.06l-9.953,-6.61l-4.6399,7.54l10.465,7.98l4.465,9.6l-1.06,11.73l-10.482,9.95l1.305,10.38l-4.267,4.36l-11.245,1.28l-0.712,-5.5l-10.9541,3.77l-2.9769,18.06l-5.702,6.1l-11.2831,-0.59l-1.194,4.82l6.6921,7.62l-0.9671,8.68l-6.384,5.79l-4.9,5.75l-3.226,20.55l3.819,4.6l6.785,-5.71l5.168,3.87l1.0151,6.51l-9.866,16.13l-2.1971,18.64l4.6061,4.89l-5.9791,23.82l6.444,9.99l21.6741,1.07l-0.646,7.08l-10.173,13.56l0.0369,11.26l14.9191,5.83l1.573,8.07l-11.888,12.71l0.458,11.23l-7.708,12.62l-7.211,27.38l7.832,13l0.6489,2.4l15.129,-13.79l30.566,-3.59l3.237,-28.68l8.2073,-6.49l-2.796,-14.42l15.108,-9.64l-7.199,-10.5l-6.63,-2.85l-0.569,-28.25l-10.9772,-3.62l-7.633,-18.86l19.4222,-57.44l24.276,-26.33l-7.459,-7.53l3.528,-36.41l6.639,-7.75l23.463,24.48l36.65,12.19l29.424,-30.93l-2.515,-16.98l34.209,-59.29l16.31,0.2l-6.362,-27.93l-7.997,-0.27l0.361,-24.38l31.12,-15.16l32.785,-5.77l17.302,4.98l12.002,-10.54l9.077,-26.63l23.947,0.33l17.538,8.44l14.176,17.36z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 433.15359,
            y: 2169,
            id: "vaasa",
            name: "Vaasa"
          }
        ]
      },
      {
        id: 'satakunta',
        name: 'Satakunta',
        shape: 'm316.11939,2745.66l5.848,3.67l0.8869,4.1l0.6481,3l-3.886,5.19l-3.9911,0.31l-1.6209,0.12l-2.632,-9.96l1.442,-2.76l3.305,-3.67zm21.156,-140.84l4.895,1.39l5.677,10.41l4.1489,7.61l-4.6839,5.21l-7.107,-0.02l-2.887,-0.01l-6.9081,-7.34l5.1411,-5.21l1.724,-12.04zm-19.561,187.73l6.857,-13.77l7.341,-41.9l7.526,5.01l3.814,-4.84l-0.7901,-6.59l4.7181,-24.39l-10.263,-24.05l1.938,-3.02l4.691,-1.54l7.021,2.75l5.406,-0.99l-3.634,-8.88l-11.228,-5.92l-0.8731,-7.92l7.5631,0.3l11.917,3.51l-0.339,-4.48l-6.584,-5.32l-7.0661,-14.35l2.9821,-5.66l5.5829,0.4l8.8761,10.12l6.66,0.23l-12.9021,-28.97l0.012,-26.28l-13.3979,-17.35l2.6909,-5.94l7.8461,-0.83l0.509,-4.66l-6.0191,-4.68l-3.698,-23.58l-8.9249,-5.48l-2.0571,-7.63l15.129,-13.79l30.5661,-3.59l13.3672,12.24l33.339,5.91l38.438,-32.69l11.774,-0.05l20.651,-31.7l15.547,-0.53l13.324,-27.18l18.313,9.09l11.39,-0.05l0.011,30.28l-15.512,7.49l-0.877,26.12l-18.094,1.76l-9.188,15.38l13.807,6.78l0.016,13.73l15.387,11.52l6.123,21.73l-8.664,30.28l-13.065,-4.25l-4.453,23.05l11.184,10.78l-13.791,11.64l-9.352,28.83l19.376,13.56l-2.643,13.05l-24.318,3.57l-9.222,6.99l0.896,13.38l13.073,31.95l26.147,8.68l8.556,-9.31l14.942,15.26l-6.829,23.96l12.314,21.28l-10.109,1.59l-15.557,-5.22l-2.016,26.94l-24.94,-6.83l-23.51,7.14l5.149,6.49l-26.439,7.01l-18.928,-3.55l-15.825,14.23l-5.556,-8.18l-26.859,-2.6l-10.449,-29.39l-11.4683,-10.35l-20.9579,15.14l-1.087,-25.88l-13.023,9.81l-11.1571,0.86l-11.1049,-15.66z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 383.15359,
            y: 2644,
            id: "pori",
            name: "Pori"
          }
        ]
      },
      {
        id: 'southwestFinland',
        name: 'Southwest Finland',
        shape: 'm589.00759,2832.03l-7.828,1.01l1.346,-10.47l-19.387,3.78l-11.69,-13.76l-15.557,-5.22l-2.015,26.94l-24.941,-6.83l-23.509,7.13l5.148,6.49l-26.439,7.02l-18.928,-3.56l-15.824,14.24l-5.557,-8.18l-26.858,-2.6l-10.45,-29.39l-11.468,-10.35l-20.958,15.14l-1.086,-25.88l-13.024,9.81l-11.158,0.86l-11.214,-15.81l-4.508,-6.66l-8.284,4.62l4.333,23.79l10.921,11.33l-2.25,7.72l-6.825,-5.4l-6.444,-12.96l-7.311,0.48l-3.81901,4l6.48701,6.94l-0.455,7.81l-13.302,2.68l0.854,5.65l15.181,9.2l-1.572,5.05l-3.215,2.2l-1.84001,5.4l2.41801,9.15l0.536,13.12l5.094,8.08l-0.322,17.97l10.982,28.79l14.276,12.55l4.347,18.64l11.153,-1l4.956,-21.48l20.15,-10.81l6.765,3.04l-6.884,17.77l-7.891,-0.76l-7.258,10.2l-0.763,7.98l16.611,-4.06l21.274,-0.66l8.009,7.74l-0.396,7.91l-7.433,-0.37l-3.207,3.98l10.891,9.94l8.834,-5.69l3.491,2.74l-1.672,20.97l8.025,0.51l9.907,9.4l37.664,-7.26l5.596,-4.85l8.963,6.82l-14.72,23.52l0.039,9.63l15.69,-0.38l9.838,8.9l22.908,-6.75l35.435,-27.39l5.582,9.3l-8.484,10.34l-20.884,25.45l3.987,21.09l6.691,4.03l9.148,5.51l-0.531,4.54l24.986,-0.46l18.813,-19.69l9.621,7.65l28.612,-14.21l16.015,7.5l-1.1,-34.16l14.902,-5.13l2.949,-19.75l9.852,-1.04l-3.191,-19.21l-10.166,-4.13l1.322,-13.77l23.184,-3.18l11.06,-24.75l-5.506,-9.44l4.871,-6.97l-31.437,-10.41l-35.463,-27.22l-19.19,9.58l-25.332,-13l-0.761,-11.93l6.804,-6.09l-8.24,-9.63l1.392,-13.91l14.566,-2.97l8.15,-19l-12.191,-7.29l0.109,-7.76z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 423.15359,
            y: 2976,
            id: "turku",
            name: "Turku"
          }
        ]
      },
      {
        id: 'centralOstrobothnia',
        name: 'Central Ostrobothnia',
        shape: 'm885.59859,2078.57l-61.329,-75.05l-16.445,-49.44l-14.754,-5.81l-4.983,-20.95l-10.789,-5.62l-9.424,-37.62l-58.069,-38.28l-9.67,14.73l-1.203,23.5l-9.486,1.65l-11.824,-11.29l-7.989,5.7l-1.053,45.74l-47.806,2.16l-5.849,8.55l-6.594,0.14l-5.969,-7.19l-13.053,-0.07c-0.33,0.49 -0.403,0.04 -0.732,0.53l14.273,39.26l6.222,-8.43l32.693,24.42l23.092,-11.26l6.048,8.99l10.622,-8.23l36.775,29.56l-8.372,8.98l-17.263,0.4l-10.754,-8.77l-13.741,8.89l9.069,16.03l8.416,-2.4l20.42,37.06l-7.796,26.02l27.172,35.13l24.577,7.38l25.292,31.96l-12.989,5.36l29.43,13.92l5.875,-3.84l26.271,-9.69l22.9,4.99l2.541,-69.45l24,-25.57l12.248,-2.09z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 643.15359,
            y: 1946,
            id: "kokkola",
            name: "Kokkola"
          }
        ]
      },
      {
        id: 'pirkanmaa',
        name: 'Pirkanmaa',
        shape: 'm734.16159,2410.36l-11.337,-4.71l-2.943,-24.23l-11.517,-7.33l-25.748,21.2l-20.879,-2.98l-3.873,9.8l-27.707,-10.82l-14.337,25.29l-31.449,17.17l-28.639,-0.24l0.009,30.28l-15.51,7.48l-0.877,26.13l-18.094,1.75l-9.187,15.39l13.806,6.78l0.015,13.73l15.388,11.51l6.123,21.74l-8.665,30.28l-13.066,-4.25l-4.453,23.05l11.183,10.78l-13.79,11.64l-9.352,28.83l19.376,13.55l-2.644,13.06l-24.317,3.56l-9.223,7l0.899,13.38l13.073,31.95l26.148,8.68l8.556,-9.31l14.943,15.25l-6.832,23.97l12.316,21.28l-10.109,1.59l11.69,13.76l19.387,-3.78l-1.346,10.47l7.931,-1.51l10.286,-6.3l14.263,10.82l2.28,10l14.462,-0.22l29.912,-11.4l20.474,22.37l5.114,-5.01l-4.223,-32.38l68.785,-26.1l8.819,-10.5l-3.317,-3.91l-0.372,-6.48l3.453,-5.42l4.769,3.61l28.545,-22.38l24.791,9.64l5.416,-12.24l11.768,11.76l17.579,-7.87l-2.195,-52.6l8.628,4.99l1.188,-23.39l-18.385,-15.17l-2.149,-12.78l4.286,-9.44l9.685,-6.77l-9.933,-5.91l-2.422,1.37l-7.546,-4.53l1.122,-12.04l-2.861,-9.71l5.503,-3.68l2.186,6.1l7.177,-0.45l0.084,-6.38l-7.015,-1.23l-34.075,-42.57l13.394,-19.41l4.278,7.61l14.38,-22.99l-7.127,-26.15l-22.393,-23.78l-12.815,4.6l-20.537,-4.08l-7.713,-22.03l-11.21,2.11l-21.356,-12.77l0.068,-28.08z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 660.15359,
            y: 2636,
            id: "tampere",
            name: "Tampere"
          }
        ]
      },
      {
        id: 'northOstrobothnia',
        name: 'North Ostrobothnia',
        shape: 'm1535.69359,1432.42l5.56,-18.76l-10.67,-17.68l28.22,-18.79l19.18,-1.8l-8.71,-61.2l-29.52,-84.18l-24.76,-36.49l-18.71,-50.39l-45.23,5.81l-74.24,-17.41l0.49,16.64l-14.98,5.93l-4.89,18.33l12.64,27.19l18.45,7.77l-4.54,31.27l-9.37,1.46l-0.31,17.33l12.53,9.13l0.35,16.79l-5.46,4.46l-18.11,-5.15l-18.34,8.88l14.74,22.2l-1.13,19.02l-29.8,13.02l-67.429,-10.67l-13.85,-34.37l-10.294,4.87l-13.556,-6.16l-42.458,69.17l-31.138,10.61l-91.844,-7.95l-3.501,-29.98l-46.467,29.28l-53.354,-3.05l-3.186,14.75l-21.272,11.05l-14.351,14.63c0.613,0.64 1.229,1.27 1.842,1.9l0.568,13.06l6.954,0.03l4.646,-4.28l18.675,33.23l-1.013,12.42l-8.164,8.67l0.026,14.61l-6.291,7.69l5.439,10.03l-0.097,31.14l-8.678,11.63l4.383,9.55l12.399,7.16l5.287,9.68l3.143,20.75l9.406,9.59l-0.777,5.69l-6.402,-0.31l-14.396,-11.64l-13.39,-1.16l-2.353,6.68l1.157,8.53l19.521,19.59l3.929,11.77l-5.134,4.65l-8.968,-0.78l-1.771,-10.48l-19.592,-11.37l-18.302,-0.15l-9.464,7.37l-21.419,0.22l-7.164,6.37l-4.227,7.66l-12.354,1.43l-5.124,26.49l-19.122,13.29l-10.166,43.02l-12.632,9.76l-0.883,6.98l-17.422,11.54l-20.213,21.67l-3.015,7.17l-7.681,12.6l-0.23,14.69l-6.117,3.31l-7.512,-4.98l-8.962,13.56l-7.425,5.98l-7.422,11.31l57.929,38.51l9.423,37.63l10.789,5.61l4.982,20.95l14.755,5.81l16.445,49.44l61.857,75.33l17.486,-2.31l6.477,-40.24l14.721,-6.11l46.666,32.01l23.586,0.07l9.487,7.92l8.912,18.81l30.854,-0.22l16.136,-45.65l8.271,-4.96l-7.451,-75.6l49.737,-45.96l34.397,-11.58l-10.836,-13.63l0.008,-70.04l-15.597,-10.38l-11.723,1.63l-14.485,-12.69l2.275,-14.18l-7.396,-16.38l-13.218,-8.67l25.056,-25.56l13.211,-3.88l4.921,-15.92l28.358,-13.83l10.009,-29.03l25.887,-12.34l0.84,-7.39l30.441,7.01l5.715,-15.38l-2.465,-40.86l-17.13,-14.33l12.694,-20.84l27.861,0.12l14.498,-10.81l16.14,2.1l14.2,9.81l6.104,-37.52l14.88,-9.06l72.27,-12.97l3.36,-33.55l40.9,-19.3l8.68,7.1l14.77,-4.45l12.44,-26.64l6.03,5l34.95,1.65l36.71,-7.13z',
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 986.15359,
            y: 1600,
            id: "oulu",
            name: "Oulu"
          }
        ]
      },
      {
        id: 'aland',
        name: 'Åland',
        shape: `m305.06,3002.37949l-8.31,-1.73l-1.69,-31.8l6.26,-0.37l10.74,15.75l-7,18.15zm-33.18,-12.36l8.01,-5.12l7.61,11.92l-2.56,11.6l-7.87,4.32l-6.56,-14.69l1.37,-8.03zm14.43,25.94l10.63,-9.02l6.74,8.03l-2.56,14.63l-5.25,4.75l-6.56,-3.89l-3,-14.5zm-13.61,20.12l-7.87,2.16l-5.25,-5.62l3.26,-10.13l9.8,4.15l0.06,9.44zm-23.62,1.3l-7.43,1.6l-2.63,-3.33l0,-0.43l2.82,-8.84l5.86,-4.06l5.31,5.12l-3.93,9.94zm8.75,21.17l-10.05,8.95l-4.82,-3.34l-0.87,-4.32l-0.24,-8.83l8.93,-4.07l5.31,7.28l1.74,4.33zm-21.45,12.93l1.33,6.4l-10.07,0.12l-3.06,-12.1l3.26,-5.38l6.3,1.12l2.25,5.56l-0.01,4.28zm-8.8,12.2l6.19,13.33l-1.32,2.99l-0.42,5.09l-11.82,-0.74l-2.74,-12.04l-5.56,-6.1l5.88,-8.41l9.79,5.88zm-32.72,-54.2l-22.75,-1.61l0.44,-6.91l5.88,-4.51l16.41,7.93l0.02,5.1zm-12.7,12.22l5.88,-4.52l3.8,6.24l-3.22,7.37l5.13,7.74l-8.11,11.21l-5.23,-0.08l0.87,-14.85l-6.13,-6.2l7.01,-6.91zm23.24,74.74l5.09,6.08l-6.68,8.17l-20.79,6.03l-15.29,-0.52l-3.07,-4.91l13.99,-11.39l7.63,-5.81l19.12,2.35zm-12.3,-14.53l4.56,-5.1l5.83,1.09l6.88,6.43l0.2,4.74l-12.23,-1.38l-5.24,-5.78zm-30.83,-4.49l3.26,7.33l-10.91,-0.09l-1.75,-15.27l9.81,-11.59l3.8,0.63l1.59,8.23l-5.8,10.76zm-9,6.75l0.08,6.67l-3.43,7.59l6.05,6.18l-1.05,7.55l-9.97,6.8l-2.52,-10.49l-6.46,1.22l-4.67,-10.52l-14.03,-9.89l-12.36,2.69l-1.71,-10.45l-4.78,-5.99l-9.57,-0.97l-5.73,-6.35l-1.65,-12.17l-9.81,-11.12l-6.68,0.1l-5.37,-1.21l-2.81,9.58l-7.56,0.41l-5.55,-12.25l2.99,-12.95l-5.36,-5.67l3.33,-8.66l19.42,-8.17l8.82,2.75l9.43,-1.42l7.55,-9.53l8.38,5.27l-2.3,14.82l6.2,1.56l5.3,-5.98l-1.95,-4.39l-0.04,-6.14l-4.63,-7.82l-14.44,-2.04l12.68,-16.42l12.44,-5.37l15.98,15.28l14.75,2.67l6.47,10.73l8.5,3.61l1.33,10.41l10.08,12.11l-7.44,21.51l-17.76,2.84l-11.2,-12.21l-6.79,-0.66l-5.8,9.91l10.15,7.58l-8.53,19.91l2.13,3.43l8.4,0.23l5.1,-3.31l16.39,8.74zm95.81,51.76l13.75,-6.4l4.08,2.81l7.76,3.85l-2.09,3.41l-1.79,5.43l-5.96,-0.17l-5.26,8.16l-13.1,-9.59l2.61,-7.5z`,
        center: {
          x: 200,
          y: 200
        },
        cities: [
          {
            x: 118.33378,
            y: 3105.64361,
            id: "mariehamn",
            name: "Mariehamn"
          }
        ]
      },
    ],
    campaigns: [],
    policies: [],
    campaign: null,
    users: [],
    pages: [],
    statistics: null,
    snackbar: {
      show: false,
      message: null,
      timeout: null,
      color: "primary"
    }
  },
  mutations: {
    mutateJWT(state, JWT) {
      state.JWT = JWT;
    },
    mutateCategories(state, categories) {
      state.categories = categories;
    },
    mutateCategoriesWithDetails(state, categories) {
      state.categoriesWithDetails = categories;
    },
    mutateTags(state, tags) {
      state.tags = tags;
    },
    mutateJobs(state, data) {
      state.jobs = data;
      state.searchResults = data;
      console.log(data);

      // Remove deleted jobs from results
      state.searchResults = state.searchResults.filter((job) => !(job.status.hiddenBecause && job.status.hiddenBecause.deleted));

      // Hide duplicate categories
      state.searchResults = state.searchResults.map(
        (job) => {
          job.clustering.categories = job.clustering.categories.filter((item, index, array) => {
            return array.findIndex((c) => c.id == item.id) == index;
          })
          return job;
        }
      );

      if(state.searchResults.length > 0){
        state.searchResults.forEach((element) => {
          Vue.set(element, 'match', true);
          Vue.set(element, 'sortKey', /*element.reviewed + */element.firstSeen + (!element.imageUrl));
        });
      }
    },
    mutateCampaignJobs(state, data){
      state.campaignJobs = data;
      state.searchResults = data;
      if(state.campaignJobs.length > 0){
        state.campaignJobs.forEach((element) => {
          Vue.set(element, 'match', true);
          Vue.set(element, 'sortKey', element.firstSeen + (!element.imageUrl));
        });
      }
    },
    mutateSearchResults(state, filters) {
      // First check if there are search terms at all
      if (!filters.area && !filters.keywords) {
        state.searchResults.forEach((element) => {
          Vue.set(element, 'match', true);
        });
      } else {
        if(state.searchResults !== null){
        state.searchResults.forEach((element) => {
          // Check each entry in array for results, and set the match status false/true:
          const { title } = element;
          const employer = element.employer.name;
          const { city } = element.location;
          const { area } = element.location;
          const { categories, tags } = element.clustering ? element.clustering : { categories: '', tags: '' };
          const titleMatch = (filters.keywords) ? RegExp(filters.keywords, 'gi').test(title) : false;
          const employerMatch = (filters.keywords) ? RegExp(filters.keywords, 'gi').test(employer) : false;
          const areaMatch = (filters.area) ? RegExp(filters.area, 'gi').test(area) : false;
          const cityMatch = (filters.area) ? RegExp(filters.area, 'gi').test(city) : false;

            const categoryMatch = (filters.keywords && categories.length) ? categories.reduce((found, category) => found || RegExp(filters.keywords, 'gi').test(category.name), false) : false;
            const topicMatch = (filters.keywords && tags.length) ? tags.reduce((found, tag) => found || RegExp(filters.keywords, 'gi').test(tag.name), false) : false;

            const keywordMatch = !!((categoryMatch || topicMatch || titleMatch || employerMatch));
            if (filters.keywords && !filters.area) {
              // No area specified, match all keyword results
              // eslint-disable-next-line no-unused-expressions
              (keywordMatch) ? Vue.set(element, 'match', true) : Vue.set(element, 'match', false);
            } else if (!filters.keywords && filters.area) {
              // Area specified, but no keyword. Match all area results
              // eslint-disable-next-line no-unused-expressions
              (areaMatch || cityMatch) ? Vue.set(element, 'match', true) : Vue.set(element, 'match', false);
            } else if (filters.keywords && filters.area) {
              // Keywords and area specified, match only where both apply
              // eslint-disable-next-line no-unused-expressions
              ((keywordMatch && cityMatch) || (areaMatch && keywordMatch)) ? Vue.set(element, 'match', true) : Vue.set(element, 'match', false);
            }
          });
        }
      }
    },
    mutateSearchTerms(state, filters) {
      state.searchTerms = filters;

      if(filters.keywords !== null && filters.keywords.length > 0)
      AnalyticsService.pushEvent('CategorySelection', filters.keywords);
      
      if(filters.area !== null && filters.area.length > 0)
      AnalyticsService.pushEvent('LocationSelection', filters.area);
    },
    mutateSelectedPosition(state, item) {
      state.selectedPosition = item;
    },
    mutateMapVisibility(state, val) {
      state.mapVisibility = val;
    },
    mutateReasonsToReport(state, reasons) {
      state.reasonsToReport = reasons;
    },
    mutateReasonsToHide(state, reasons) {
      state.reasonsToHide = reasons;
    },
    mutateReasonsToHideAdmin(state, reasons) {
      state.reasonsToHideAdmin = reasons;
    },
    mutateFavorites(state, data){
      console.log(data);
      let index;
      let favorite;
      switch(data.action){
        case 'add':
          if(state.userFavorites.findIndex(item => item.id == data.jobId) > -1) return;
          
          favorite = state.searchResults.find(item => item.id == data.jobId);
          AnalyticsService.pushEvent('AddToCart', favorite.title, { employer: favorite.employer.name, location: favorite.location.area, city: favorite.location.city });
          state.userFavorites.push(favorite);
          break;
        case 'remove':
          index = state.userFavorites.findIndex(item => item.id == data.jobId);
          favorite = state.userFavorites[index];
          AnalyticsService.pushEvent('RemoveFromCart', favorite.title, { employer: favorite.employer.name, location: favorite.location.area, city: favorite.location.city });
          state.userFavorites.splice(index, 1);
          break;
        case 'clear':
          state.userFavorites = [];
          break;
      }
      // Update localStorage and reset TTL
      console.log('Update favorites in local storage');
      let payload = {
        expiry: new Date().getTime() + 1000 * 60 * 60 * 24,
        items: state.userFavorites
      }
      localStorage.favorites = JSON.stringify(payload);
      
    },
    mutateCampaigns(state, campaigns) {
      state.campaigns = campaigns;
    },
    mutateCampaign(state, campaign) {
      state.campaign = campaign;
    },
    mutatePolicies(state, policies) {
      state.policies = policies;
    },
    mutateUsers(state, users) {
      state.users = users;
    },
    mutateUserRoles(state, roles) {
      state.userRoles = roles;
    },
    mutatePages(state, pages) {
      state.pages = pages;
    },
    mutateStatistics(state, statistics) {
      state.statistics = statistics;
    },
    mutateSnackbar(state, snackbar){
      state.snackbar = snackbar;
    }
  },
  actions: {
    commitJWT: ({ commit }, context) => new Promise((resolve, reject) => {
      commit('mutateJWT', context);
      resolve();
    }),
    commitCategories: ({ commit }, context) => {
      commit('mutateCategories', context);
    },
    commitCategoriesWithDetails: ({ commit }, context) => {
      commit('mutateCategoriesWithDetails', context);
    },
    commitTags: ({ commit }, context) => {
      commit('mutateTags', context);
    },
    commitJobs: ({ commit }, context) => {
      commit('mutateJobs', context);
    },
    commitCampaignJobs: ({ commit }, context) => {
      commit('mutateCampaignJobs', context);
    },
    commitMapVisibility: ({ commit }, context) => {
      commit('mutateMapVisibility', context);
    },
    commitSearchTerms: ({ commit }, context) => {
      commit('mutateSearchTerms', context);
    },
    commitSearchResults: ({ commit }, context) => {
      commit('mutateSearchResults', context);
    },
    commitSelectedPosition: ({ commit }, context) => {
      commit('mutateSelectedPosition', context);
    },
    commitReasonsToReport: ({ commit }, context) => {
      commit('mutateReasonsToReport', context);
    },
    commitReasonsToHide: ({ commit }, context) => {
      commit('mutateReasonsToHide', context);
    },
    commitReasonsToHideAdmin: ({ commit }, context) => {
      commit('mutateReasonsToHideAdmin', context);
    },
    commitFavorite: ({ commit }, context) => {
      commit('mutateFavorites', context);
    },
    commitCampaigns: ({ commit }, context) => {
      commit('mutateCampaigns', context);
    },
    commitCampaign: ({ commit }, context) => {
      commit('mutateCampaign', context);
    },
    commitPolicies: ({ commit }, context) => {
      commit('mutatePolicies', context);
    },
    commitUsers: ({ commit }, context) => {
      commit('mutateUsers', context);
    },
    commitUserRoles: ({ commit }, context) => {
      commit('mutateUserRoles', context);
    },
    commitPages: ({ commit }, context) => {
      commit('mutatePages', context);
    },
    commitStatistics: ({ commit }, context) => {
      commit('mutateStatistics', context);
    },
    commitSnackbar: ({ commit }, context) => {
      commit('mutateSnackbar', context);
    },
    
    // Client storage calls

    fetchFavorites(){
      console.log('Fetch favorites from local storage');
      if(localStorage.favorites){
        let data = JSON.parse(localStorage.favorites);
        console.log(data.expiry - new Date().getTime());
        if(data.expiry && (data.expiry > new Date().getTime())){
          this.state.userFavorites = data.items;
        }
        else{
          this.state.userFavorites = [];
        }
      }
    },

    // Api calls

    dispatchLogin: ({ dispatch }, { username, password }) => new Promise((resolve, reject) => {
      api.login(username, password).then((response) => {
        const JWT = response.data.jwt;
        dispatch('commitJWT', JWT).then(() => resolve(response.data));
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchResetPassword: ({ dispatch }, { token, newPassword }) => new Promise((resolve, reject) => {
      api.resetPassword(token, newPassword).then((response) => {
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchForgotPassword: ({ dispatch }, { identifier }) => new Promise((resolve, reject) => {
      api.forgotPassword(identifier).then((response) => {
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetJobsAdmin: ({ dispatch, state }) => new Promise((resolve, reject) => {
      api.getAdminJobs(state.JWT).then((response) => {
        const { data } = response;
        console.log(response);
        dispatch('commitJobs', data);
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetJobs: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getJobs().then((response) => {
        const { data } = response;
        console.log(response);
        dispatch('commitJobs', data);
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetCampaignJobs: ({ dispatch }, { campaignId, replaceResults = true }) => new Promise((resolve, reject) => {
      api.getJobsForCampaign(campaignId).then((response) => {
        const { data } = response;
        console.log(response);
        if (replaceResults) dispatch('commitCampaignJobs', data);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPutAdminCampaignJobs: ({ state }, { campaignId, jobIds }) => new Promise((resolve, reject) => {
      api.putAdminCampaignJobs(state.JWT, campaignId, jobIds).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPutAdminJob: ({ state }, { jobId, jobData }) => new Promise((resolve, reject) => {
      api.putAdminJob(state.JWT, jobId, jobData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostJob: ({ state }, { jobData }) => new Promise((resolve, reject) => {
      api.postJob(jobData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostAdminJob: ({ state }, { jobData }) => new Promise((resolve, reject) => {
      api.postAdminJob(state.JWT, jobData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostAdminAcceptJob: ({ state }, { jobData, reviewerData }) => new Promise((resolve, reject) => {
      api.postAdminAcceptJob(state.JWT, jobData, reviewerData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostAdminDeclineJob: ({ state }, { jobData, reviewerData }) => new Promise((resolve, reject) => {
      api.postAdminDeclineJob(state.JWT, jobData, reviewerData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchCategories: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getCategories().then((response) => {
        const data = Object.values(response.data).map(category => category.keywords);
        dispatch('commitCategories', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchCategoriesWithDetails: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getCategories().then((response) => {
        const { data } = response;
        console.log(response);
        dispatch('commitCategoriesWithDetails', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchTags: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getTags().then((response) => {
        const data = Object.values(response.data).map(tags => tags.id);
        dispatch('commitTags', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchReport: ({ state }, { jobId, report }) => new Promise((resolve, reject) => {
      console.log(jobId, report);
      api.postReportJob(jobId, report).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchReasonsToReport: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getReasonsToReport().then((response) => {
        const data = response.data;
        dispatch('commitReasonsToReport', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchReasonsToHide: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getReasonsToHide().then((response) => {
        const data = response.data;
        dispatch('commitReasonsToHide', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchReasonsToHideAdmin: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getReasonsToHide().then((response) => {
        const data = response.data;
        console.log(data);
        dispatch('commitReasonsToHideAdmin', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetCampaigns: ({ dispatch, state }) => new Promise((resolve, reject) => {
      api.getAdminCampaigns(state.JWT).then((response) => {
        const { data } = response;
        console.log(response);
        dispatch('commitCampaigns', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetCampaign: ({ dispatch, state }, { campaignId }) => new Promise((resolve, reject) => {
      api.getCampaign(campaignId).then((response) => {
        const { data } = response;
        console.log(response);
        dispatch('commitCampaign', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetPolicies: ({ dispatch, state }) => new Promise((resolve, reject) => {
      api.getAdminPolicies(state.JWT).then((response) => {
        const { data } = response;
        dispatch('commitPolicies', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostPolicies: ({ state }, { policies }) => new Promise((resolve, reject) => {
      console.log(policies);
      api.postAdminPolicies(state.JWT, policies).then((response) => {
        const { data } = response;
        console.log(data);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostPolicy: ({ state }, { policy }) => new Promise((resolve, reject) => {
      api.postAdminPolicy(state.JWT, policy).then((response) => {
        const { data } = response;
        console.log(data);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchUpdatePolicy: ({ state }, { policy }) => new Promise((resolve, reject) => {
      api.putAdminPolicy(state.JWT, policy.id, policy).then((response) => {
        const { data } = response;
        console.log(data);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchDeletePolicy: ({ state }, { id }) => new Promise((resolve, reject) => {
      api.deleteAdminPolicy(state.JWT, id).then((response) => {
        const { data } = response;
        console.log(data);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostCampaign: ({ state }, { campaignData }) => new Promise((resolve, reject) => {
      api.postAdminCampaign(state.JWT, campaignData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPutCampaign: ({ state }, { campaignData, id }) => new Promise((resolve, reject) => {
      api.putAdminCampaign(state.JWT, id, campaignData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetCampaignsWithJobs: ({ dispatch, state }) => new Promise((resolve, reject) => {
      // Get a list of all the campaigns
      api.getAdminCampaigns(state.JWT).then((campaigns) => {
        let campaignList = campaigns.data;
        // Get jobs for each campaign
        campaignList.forEach((campaign, index) => {
          campaignList[index]['jobs'] = [];
          api.getJobsForCampaign(campaign.id).then((jobs) => {
            let jobList = jobs.data;
            campaignList[index]['jobs'] = jobList;
            if(index == campaignList.length - 1){
              resolve(campaignList);
            }
          });
        });
      });
      
    }),
    dispatchGetUsers: ({ dispatch, state }) => new Promise((resolve, reject) => {
      api.getUsers(state.JWT).then((response) => {
        const { data } = response;
        console.log(response);
        dispatch('commitUsers', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetUser: ({ dispatch, state }, { userId }) => new Promise((resolve, reject) => {
      api.getUser(state.JWT, userId).then((response) => {
        const { data } = response;
        console.log(response);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetRoles: ({ dispatch, state }) => new Promise((resolve, reject) => {
      api.getRoles(state.JWT).then((response) => {
        const { data } = response;
        console.log(response);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetUserRoles: ({ dispatch, state }, { userId, own = false }) => new Promise((resolve, reject) => {
      api.getUserRoles(state.JWT, userId).then((response) => {
        const { data } = response;
        console.log(response);
        if(own) dispatch('commitUserRoles', data);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostUser: ({ state }, { userData }) => new Promise((resolve, reject) => {
      console.log(userData);
      api.postUser(state.JWT, userData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPutUser: ({ state }, { userData, id }) => new Promise((resolve, reject) => {
      api.putUser(state.JWT, id, userData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPutUserRoles: ({ state }, { userId, userRoles }) => new Promise((resolve, reject) => {
      api.putUserRoles(state.JWT, userId, userRoles).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetPages: ({ dispatch }) => new Promise((resolve, reject) => {
      api.getPages().then((response) => {
        const { data } = response;
        console.log(data);
        dispatch('commitPages', data);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPutPage: ({ state }, { pageData, id }) => new Promise((resolve, reject) => {
      api.putPage(state.JWT, id, pageData).then((response) => {
        const { data } = response;
        console.log(response);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchGetStatistics: ({ dispatch }, { campaignId }) => new Promise((resolve, reject) => {
      api.getStatistics().then((response) => {
        const { data } = response;
        console.log(data);
        dispatch('commitStatistics', data);
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }),
    dispatchPostContactForm: ({ state }, { formData }) => new Promise((resolve, reject) => {
      api.postContactForm(formData).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    }),
  },
});
